import React, { useState } from "react";
import _ from "lodash";
// @ts-ignore
import ReactBootstrapSlider from "react-bootstrap-slider";
// @ts-ignore
import styles from "../../styles/slider.css";

const FilterByConfidence = ({
  updateFilter,
  confidenceLevel
}: {
  updateFilter: (filter: string) => void;
  confidenceLevel: number;
}) => {
  const updateConfidence = (event: any) => {
    updateFilter(event.target.value);
  };

  return (
    <div className="accuracy-wrap filter-s">
      <div className="small-label">Accuracy Level</div>
      <p>
        High = you'll find images that are of you. Low = you'll find images that
        look like you.
      </p>
      <p>
        To get more results where your face is in the background decrease
        accuracy
      </p>
      <div className="dv-rslider">
        <ReactBootstrapSlider
          value={confidenceLevel}
          slideStop={updateConfidence}
          step={1}
          min={60}
          max={95}
          tooltip={"hide"}
        />
        <p className="p-bold">Low</p>
        <p className="p-bold">High</p>
      </div>
    </div>
  );
};

export default FilterByConfidence;
